module.exports = __webpack_public_path__ + "static/media/rotation.73e64184.svg";